// extracted by mini-css-extract-plugin
module.exports = {"modalTooltipDialogContainer":"SaveInfoButton_modalTooltipDialogContainer__1vYIc","tooltipDialogMessageContainer":"SaveInfoButton_tooltipDialogMessageContainer__1JAWA"};